export function ColorType(e) {
  switch (e) {
    case "fire": {
      return "#EE8130";
    }
    case "grass": {
      return "#7AC74C";
    }
    case "electric": {
      return "#ffd76f";
    }
    case "water": {
      return "#6390F0";
    }
    case "bug": {
      return "#A6B91A";
    }
    case "ice": {
      return "#96D9D6";
    }
    case "rock": {
      return "#B6A136";
    }
    case "flying": {
      return "#A98FF3";
    }
    case "normal": {
      return "#A8A77A";
    }
    case "poison": {
      return "#A33EA1";
    }
    case "ground": {
      return "#E2BF65";
    }
    case "fairy": {
      return "#D685AD";
    }
    case "fighting": {
      return "#C22E28";
    }
    case "psychic": {
      return "#F95587";
    }
    case "ghost": {
      return "#735797";
    }
    case "dragon": {
      return "#6F35FC";
    }
    case "dark": {
      return "#705746";
    }
    case "steel": {
      return "#B7B7CE";
    }
    case "shadow": {
      return "#474747";
    }
    case "unknown": {
      return "#325734";
    }
    default: {
      return "#325734";
    }
  }
}
export function ColorPills(e) {
  switch (e) {
    case "fire": {
      return "rgba(255, 173, 110, 0.7)";
    }
    case "grass": {
      return "rgba(170, 235, 131, 0.7)";
    }
    case "electric": {
      return "rgba(245, 223, 166,0.7)";
    }
    case "water": {
      return "rgba(139, 173, 247,0.7)";
    }
    case "bug": {
      return "rgba(206, 227, 50, 0.7)";
    }
    case "ice": {
      return "rgba(181, 247, 244, 0.7)";
    }
    case "rock": {
      return "rgba(235, 210, 82, 0.7)";
    }
    case "flying": {
      return "rgba(202, 184, 255, 0.7)";
    }
    case "normal": {
      return "rgba(204, 203, 155, 0.7)";
    }
    case "poison": {
      return "rgba(219, 99, 217, 0.7)";
    }
    case "ground": {
      return "rgba(255, 222, 140, 0.7)";
    }
    case "fairy": {
      return "rgba(242, 174, 208, 0.7)";
    }
    case "fighting": {
      return "rgba(227, 83, 77, 0.7)";
    }
    case "psychic": {
      return "rgba(255, 122, 163, 0.7)";
    }
    case "ghost": {
      return "rgba(163, 133, 201, 0.7)";
    }
    case "dragon": {
      return "rgba(148, 105, 255, 0.7)";
    }
    case "dark": {
      return "rgba(199, 161, 135, 0.7)";
    }
    case "steel": {
      return "rgba(223, 223, 242, 0.7)";
    }
    case "shadow": {
      return "rgba(71, 71, 71,0.7)";
    }
    default: {
      return "#325734";
    }
  }
}
